export const CAR_TYPES = [
  {
    id: "6426d46c7cfcc6b82fc1c23f",
    categoryType: "STANDARD SEDAN",
    description: "Corolla, Toyota Prius, Camry, Ford Taurus or similar",
  },
  {
    id: "6426d4c57cfcc6b82fc1c246",
    categoryType: "PREMIUM SEDAN",
    description:
      "Mercedes E Class, BMW 5 Series, Audi A6, VW Passat, Lexus or similar",
  },
  {
    id: "6426d4fd7cfcc6b82fc1c24e",
    categoryType: "ECONOMY VAN",
    description:
      "Opel Vivaro, Ford, Volkswagen Caravelle, Honda Odyssey or similar",
  },
  {
    id: "6426d5527cfcc6b82fc1c259",
    categoryType: "PREMIUM VAN",
    description:
      "Mercedes Viano/V Class, Cadillac Escalade, Toyota Alphard, Chevrolet Suburban, GMC or similar",
  },
  {
    id: "6426d5c37cfcc6b82fc1c260",
    categoryType: "LUXURY SEDAN",
    description: "Mercedes S Class, BMW 7 Series, Audi A8 or similar",
  },
  {
    id: "6426d7a57cfcc6b82fc1c273",
    categoryType: "PREMIUM SUV",
    description:
      "Mercedes Viano/V Class, Cadillac Escalade, Toyota Alphard, Chevrolet Suburban, GMC or similar",
  },
  {
    id: "66dff15645ca40e86b70f21e",
    categoryType: "Large Van",
    description: "Mercedes Sprinter, Ford Vans or similar",
  },
  {
    id: "66dff1ecf6cbf1f02ed6a1ef",
    categoryType: "Coaster Bus",
    description: "Toyota Coaster bus or similar",
  },
  {
    id: "66dff24286cb94de07e53a4d",
    categoryType: "Commuter Van",
    description: "Toyota Commuter Van or similar",
  },
  {
    id: "66dff54e29471709093cee01",
    categoryType: "Large Bus",
    description: "VDL, Scania, Mercedes Bus or similar",
  },
  {
    id: "674d7d9c82f66c50e1cf17aa",
    categoryType: "Micro Sedan",
    description: "Toyota Vios or similar",
  },
  {
    id: "674d7e841fe079f0232f5ad7",
    categoryType: "Eco Suv",
    description: "Toyota Innova, Toyota Fortuner or similar",
  },
];
